import type { SceneListItem } from "@chuzi/shared/types";

/** True when the scene is a bookend (title card or credits), not authored content. */
export function isScaffoldScene(scene: SceneListItem): boolean {
  return scene.is_title || scene.is_end;
}

/** True when the story has at least one non-bookend scene. */
export function storyHasContentScenes(scenes: SceneListItem[]): boolean {
  return scenes.some((scene) => !isScaffoldScene(scene));
}

/** New stories only have Start/End bookends until the creator adds or generates content. */
export function isUninitializedStory(scenes: SceneListItem[]): boolean {
  return scenes.length > 0 && !storyHasContentScenes(scenes);
}

/** Hide End (and other non-title bookends) from editor/constellation until content exists. */
export function editorVisibleScenes(scenes: SceneListItem[]): SceneListItem[] {
  if (!isUninitializedStory(scenes)) return scenes;
  return scenes.filter((scene) => scene.is_title);
}
